import { render, staticRenderFns } from "./RflmUnpaidChildSupport.vue?vue&type=template&id=14b8c832"
import script from "./RflmUnpaidChildSupport.vue?vue&type=script&lang=ts"
export * from "./RflmUnpaidChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports